

const EventTableSkeleton = () => {
  const rows = [1, 2, 3, 4, 5]; // 5 skeleton rows

  return (
    <div className="overflow-x-auto rounded-[20px]">
      {/* Desktop Table View */}
      <table className="hidden md:table w-full border-collapse min-w-[600px] atkinson-font">
        <thead>
          <tr>
            <th className="bg-[#d9d9d9] text-black font-bold p-3 text-left text-[20px]">Event</th>
            <th className="bg-[#d9d9d9] text-black font-bold p-3 text-left text-[20px]">Date/Time</th>
            <th className="bg-[#d9d9d9] text-black font-bold p-3 text-left text-[20px]">Status</th>
            <th className="bg-[#d9d9d9] text-black font-bold p-3 text-left text-[20px]">Action</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((_row, index) => (
            <tr key={index} className={index % 2 === 0 ? "bg-[#d2d2d2]" : "bg-[#919191]"}>
              <td className="p-4 align-middle">
                <div className="h-4 w-3/4 shimmer rounded opacity-50"></div>
              </td>
              <td className="p-4 align-middle">
                <div className="h-4 w-1/2 shimmer rounded opacity-50"></div>
              </td>
              <td className="p-4 align-middle">
                <div className="h-6 w-24 shimmer rounded-lg opacity-50"></div>
              </td>
              <td className="p-4 align-middle">
                <div className="h-6 w-32 shimmer rounded-lg opacity-50"></div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Mobile Card View */}
      <div className="flex flex-col gap-[15px] p-1 md:hidden">
        {rows.map((_row, index) => (
            <div key={index} className="border border-white rounded-[10px] p-4 flex justify-between items-center bg-[#17002e] relative">
                 <div className="flex flex-col w-full gap-3">
                    <div className="h-6 w-3/4 shimmer rounded opacity-20"></div>
                    <div className="h-4 w-1/2 shimmer rounded opacity-20"></div>
                 </div>
                 <div className="h-6 w-20 shimmer rounded opacity-20"></div>
            </div>
        ))}
      </div>
    </div>
  );
};

export default EventTableSkeleton;
